// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem-module__menuItem","destructive":"MenuItem-module__destructive"};